import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

interface AppConfig {
  backendApiURL: string;
}

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  private configuration: AppConfig;

  constructor(private httpClient: HttpClient) {}

  setConfig(): Promise<any> {
    console.log(
      this.httpClient
        .get<any>("assets/config/config.json")
        .toPromise()
        .then((config) => (this.configuration = config)),
      "setConfigi"
    );
    return this.httpClient
      .get<any>("assets/config/config.json")
      .toPromise()
      .then((config) => (this.configuration = config));
  }

  readConfig(): AppConfig {
    return this.configuration;
  }
}
